import Vue from "vue";
import Vuetify from "vuetify";
import App from "./App.vue";
import VueGtag from "vue-gtag";
import router from "./router";
import store from "./store";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "vuetify/dist/vuetify.min.css";
import "@/stylus/main.styl";

// setup vuetify globally
Vue.use(Vuetify, {
  theme: {
    primary: "#324e6b",
    secondary: "#600627"
  }
});

// setup google analytics
Vue.use(
  VueGtag,
  {
    config: { id: "G-5SR06RJ6Q1" },
    appName: "Fort Meade Resiliency Services",
    pageTrackerScreenviewEnabled: true
  },
  router
);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
